export default __webpack_public_path__ + "static/media/entriesStep.665a07c2.png";